import sanitizeHtml from 'sanitize-html';
import { htmlDecode } from 'js-htmlencode';

// replaces all spaces with - then lowercases
export const sanitizeLink = (str: string) => str && str.replace(/\s/g, '-').toLowerCase();

// remove all HTML except br tags.
export const sanitizeComment = (text: string) => {
  if (!text) {
    return '';
  }

  return sanitizeHtml(htmlDecode(text.replace(/\r/g, '').split('\n').join('<br />')), {
    allowedTags: ['br'],
  });
};

type SearchPathQueryParam = string | number | boolean | null | undefined;

type SearchPathQueryParams = Record<string, SearchPathQueryParam>;

// builds a path after replacing spaces and plus signs in each segment with dashes
export const SANITIZE_SEARCH_TERM_REGEX = /[\s+]/g;
export const buildSearchPath = (pathSegments: Array<string | number>, queryParams: SearchPathQueryParams = {}) => {
  const sanitizedPathSegments = pathSegments.map((pathSegment) =>
    String(pathSegment).trim().replace(SANITIZE_SEARCH_TERM_REGEX, '-'),
  );
  const path = ['/search', ...sanitizedPathSegments].join('/');
  const searchParams = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    // not being strict here with equality check to catch both undefined and null together
    searchParams.append(key, value == null ? '' : String(value));
  });

  const serializedQueryParams = searchParams.toString();

  return serializedQueryParams ? `${path}?${serializedQueryParams}` : path;
};
